<template>
  <v-dialog v-model="dialog" width="800">
    <v-card>
      <v-card-title class="text-h5 primary white--text d-flex flex-nowrap justify-space-between align-center">
        {{ $t('guide.productionPlace.title') }}
        <v-btn icon dark @click="closeDialog">
          <v-icon :style="{color: '#ffffff !important'}">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <div class="black--text text-body-1 mb-2">
          <p>{{ $t('guide.productionPlace.description') }}</p>
          <h6 class="text-h6 mt-3">
            {{ $t('guide.productionPlace.allowedFormat') }}<br />
            KML, GeoJSON, Shapefile (Zipped)
          </h6>
        </div>
        <v-checkbox v-model="hideDialogInFuture" :label="$t('guide.dontShowAgain')"></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" @click="closeDialog">{{ $t('dueDiligence.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: localStorage.getItem('hideCreateDDSReportGuide') !== 'true',
      hideDialogInFuture: false,
    };
  },

  methods: {
    closeDialog() {
      if (this.hideDialogInFuture) {
        localStorage.setItem('hideCreateDDSReportGuide', 'true');
      }
      this.dialog = false;
    },
  },
};
</script>
